import React, { Component, Fragment } from 'react';

import { Grid } from 'components/grid';
import { I18n } from 'components/translate';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';

import QuizSettingsBox from './QuizSettingsBox';
import DragDropComponent from './sortable/DragDropComponent';

@inject('QuizStore')
@observer
export default class QuizQuestions extends Component {
  static propTypes = {
    QuizStore: MobxPropTypes.objectOrObservableObject,
    currentTab: PropTypes.number
  };

  render() {
    const { questions, type } = this.props.QuizStore;
    const { currentTab } = this.props;

    return (
      <Fragment>
        <Grid block>
          <h2 className="mb__md">
            <I18n label="general.questions" />
          </h2>

          <div>
            <DragDropComponent
              quizType={type}
              items={questions}
              type="question"
              droppableId="question-droppable"
            />
          </div>
        </Grid>

        <Grid block>
          <h2>
            <I18n label="general.configs" />
          </h2>

          <QuizSettingsBox currentTab={currentTab} />
        </Grid>

        <div style={{ marginBottom: 120 }} />
      </Fragment>
    );
  }
}
